import { request } from '../apis/';

export interface LeaveAllocationEmployeeDTO {
  upn: string;
  epfNumber: string;
  employeeName: string;
  annualLeave: number;
  casualLeave: number;
  lieuLeave: number;
  medicalLeave: number;
}

export interface BulkLeaveAllocationRequestDTO {
  year: number;
  employees: LeaveAllocationEmployeeDTO[];
}

export interface BulkLeaveAllocationResponseDTO {
  status: string;
  message: string;
  updatedCount: number;
  insertedCount: number;
  errors: string[];
}

export interface MaternityAllocationDTO {
  upn: string;
  epfNumber: string;
  employeeName: string;
  days: number;
  usedDays: number;
}

export interface SetMaternityAllocationRequestDTO {
  upn: string;
  year: number;
  days: number;
}

export const LeaveAllocationService = {
  getEmployeeAllocations: (year: number, search?: string) => {
    const searchParam =
      search && search.trim()
        ? `?search=${encodeURIComponent(search.trim())}`
        : '';
    return request.get<LeaveAllocationEmployeeDTO[]>(
      `AnnualLeaveAllocation/${year}${searchParam}`
    );
  },

  bulkUpsertAllocations: (data: BulkLeaveAllocationRequestDTO) => {
    return request.put<BulkLeaveAllocationResponseDTO>(
      'AnnualLeaveAllocation/bulk-upsert',
      data
    );
  },

  getMaternityAllocations: (year: number) =>
    request.get<MaternityAllocationDTO[]>(
      `AnnualLeaveAllocation/maternity/${year}`
    ),

  setMaternityAllocation: (data: SetMaternityAllocationRequestDTO) =>
    request.put<{ status: string; message: string }>(
      'AnnualLeaveAllocation/maternity',
      data
    )
};
